import {useFeatureFlag, useLogger, useSharedDispatch} from '@deliveryhero/vendor-web-core';
import {useEffect, useRef, useState} from 'react';
import {AVAILABILITY_HIGH_DEMAND_MODE, defaultHighDemand} from '../constants/FeatureFlag';
import {AVAILABILITY_HIGH_DEMAND_FLAG_CHANGED} from '../slices/AvailabilityStateSlice';
import {isValidHighDemandFlagValue} from '../utils/isValidHighDemandFlagValue';

/**
 * temporary solution,
 * to show loader in the drawer while flag is not loaded yet
 * we set initial value in the Store: highDemandFlag: undefined,
 * listen to the second value from useFeatureFlag - that should be not the default one,
 * but the one from actual api call,
 * then set this value to Store and read from Store where it is needed
 **/
export const useHighDemandFlag = (): void => {
  const [count, setCount] = useState<number>(0);
  const dispatch = useSharedDispatch();
  const failureTimeout = useRef<NodeJS.Timeout>();
  const logger = useLogger();

  const highDemandFromFwF = useFeatureFlag(AVAILABILITY_HIGH_DEMAND_MODE, defaultHighDemand);

  useEffect(() => {
    const newCount = count + 1;
    setCount(newCount);

    // handle failed FwF call - won't receive value 2nd time
    if (newCount === 1) {
      failureTimeout.current = setTimeout(() => {
        dispatch({
          type: AVAILABILITY_HIGH_DEMAND_FLAG_CHANGED,
          payload: highDemandFromFwF,
        });
      }, 10_000);
    }

    if (newCount > 1) {
      if (failureTimeout.current) {
        clearTimeout(failureTimeout.current);
      }

      if (isValidHighDemandFlagValue(highDemandFromFwF)) {
        dispatch({
          type: AVAILABILITY_HIGH_DEMAND_FLAG_CHANGED,
          payload: highDemandFromFwF,
        });
      } else {
        logger.warning('useHighDemandFlag: Invalid value received', {}, {value: highDemandFromFwF});
        dispatch({
          type: AVAILABILITY_HIGH_DEMAND_FLAG_CHANGED,
          payload: defaultHighDemand,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highDemandFromFwF]);
};
